import { render, staticRenderFns } from "./ModalModifyTheOdds.vue?vue&type=template&id=b7dfb6f0&"
import script from "./ModalModifyTheOdds.vue?vue&type=script&lang=js&"
export * from "./ModalModifyTheOdds.vue?vue&type=script&lang=js&"
import style0 from "./ModalModifyTheOdds.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports